<template>
  <v-app id="app_live_tracking">
    <v-container fluid>
      <v-row>
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">TRACKING ANALYSIS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analysis of daily traffic data of sales rep.</p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="back()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto" elevation="0" border="sm opacity-1" rounded="md" @click="allAgents()">
                <template v-slot:title>
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold">ALL</p>
                </template>
                <template v-slot:item>
                  <p class="font-weight-bold custom_page_main_sub_title_very_small_red text-h4">{{ this.totalUsersCount }}</p>
                </template>
                <template v-slot:append>
                  <v-avatar tile size="80" class="pa-3" rounded color="#F5F5F5">
                    <v-img class="ml-2" :src="require('@/img/icons/all_vechile.png')"></v-img>
                  </v-avatar>
                </template>
              </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto" elevation="0" border="sm opacity-1" rounded="md" @click="parking()">
                <template v-slot:title>
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold">NOT AVAILABLE</p>
                </template>
                <template v-slot:item>
                  <p class="font-weight-bold custom_page_main_sub_title_very_small_red text-h4">{{ this.deactiveOfficerCount }}</p>
                </template>
                <template v-slot:append>
                  <v-avatar tile size="80" class="pa-3" rounded color="#F5F5F5">
                    <v-img class="ml-0" :src="require('@/img/icons/not_availbale_vechile.png')"></v-img>
                  </v-avatar>
                </template>
              </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-card class="mx-auto custom_card_box" elevation="0" style="border: #2A8200 solid 1.6px !important;" border="sm opacity-1" rounded="md">
                <template v-slot:title>
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold">ON TRIP</p>
                </template>
                <template v-slot:item>
                  <p class="font-weight-bold text-h4">{{ this.activeOfficerCount }}</p>
                </template>
                <template v-slot:append>
                  <v-avatar tile size="80" class="pa-3" rounded color="#2A8200">
                    <v-img class="ml-0" :src="require('@/img/icons/ontrip_vechile.png')"></v-img>
                  </v-avatar>
                </template>
              </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <div class="ml-15 mt-8 d-flex align-center justify-space-between">
                <v-btn size="x-large" variant="text" class="filter-btn" @click="filterOpen = !filterOpen">
                  <v-icon class="mr-2">mdi-filter-variant</v-icon>
                  FILTER
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-divider class="mt-4 mb-4"></v-divider>

          <v-row>
            <v-col cols="12" xs="12" sm="12" >
              <p class="custom_page_component_main_title text-subtitle-1 font-weight-bold text-uppercase">
                Active sales representatives live locations
              </p>
              <v-divider class="mt-4 mb-4"></v-divider>

              <div class="live-map-wrap">
                <GMapMap
                    ref="liveMap"
                    :center="mapCenter"
                    :zoom="8.5"
                    class="custom_card_box d-flex live_tracking_map"
                    @click="closeAgentCard"
                >
                  <GMapMarker
                      v-for="m in markersArray"
                      :key="m.agentId"
                      :icon="markerIconForMarker(m)"
                      :position="m.position"
                      @click="selectMarker(m)"
                  />
                  
                  <template v-for="(group, gIndex) in dealerRouteGroups">
                    <GMapPolyline
                      v-for="(segment, sIndex) in group.segments"
                      :key="'dealer-path-' + group.routeId + '-' + gIndex + '-' + sIndex"
                      :path="segment"
                      :options="{ strokeColor: group.color, strokeOpacity: 1.0, strokeWeight: 4 }"
                    />
                  </template>
                  
                  <GMapMarker
                      v-for="dealer in routeDealers"
                      :key="'dealer-' + dealer.id"
                      :position="{ lat: Number(dealer.latitude), lng: Number(dealer.longitude) }"
                      :icon="{ url: require('@/img/icons/maker.png'), scaledSize: { width: 32, height: 32 } }"
                      @click="selectDealer(dealer)"
                  />
                  
                  <GMapInfoWindow
                      v-if="selectedDealer"
                      :key="'dealer-info-' + selectedDealerKey"
                      :position="{ lat: Number(selectedDealer.latitude), lng: Number(selectedDealer.longitude) }"
                      :opened="true"
                      :options="{ pixelOffset: { width: 0, height: -30 } }"
                      @closeclick="closeDealerCard"
                  >
                    <v-card class="custom_card_box" elevation="0" rounded="lg" style="width: 280px; border:none!important;">
                      <v-card-text class="pa-2">
                        <div class="font-weight-bold text-subtitle-2">{{ selectedDealer.dealer_name }}</div>
                        <div class="text-caption" style="opacity:0.7;">Code: {{ selectedDealer.dealer_code }}</div>
                        <v-divider class="my-2"></v-divider>
                        <div class="d-flex align-center mb-1">
                          <v-icon size="16" color="green" class="mr-2">mdi-map-marker</v-icon>
                          <div class="font-weight-medium text-caption">{{ selectedDealer.address }}</div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <v-icon size="16" color="primary" class="mr-2">mdi-cash</v-icon>
                          <div class="font-weight-medium text-caption">Outstanding: {{ selectedDealer.total_outstanding }}</div>
                        </div>
                        <v-divider class="my-2"></v-divider>
                        <div class="d-flex align-center">
                          <v-spacer></v-spacer>
                          <v-chip size="x-small" variant="outlined" class="font-weight-bold" :color="selectedDealer.status === 'NOT VISITED' ? 'red' : 'green'">
                            {{ selectedDealer.status }}
                          </v-chip>
                        </div>
                      </v-card-text>
                    </v-card>
                  </GMapInfoWindow>

                  <GMapInfoWindow
                      v-if="selectedMarker"
                      :position="selectedMarker.position"
                      :opened="true"
                      :options="{ pixelOffset: { width: 0, height: -10 } }"
                      @closeclick="closeAgentCard"
                  >
                    <v-card
                        class="custom_card_box"
                        elevation="0"
                        rounded="lg"
                        style="width: 320px; border:none!important;"
                    >
                      <v-card-text class="pa-2">
                        <div class="d-flex justify-space-between align-start">
                          <div class="d-flex align-center">
                            <v-avatar size="60" class="mr-2">
                              <v-img :src="selectedAgentAvatar"></v-img>
                            </v-avatar>
                            <div>
                              <div class="font-weight-bold text-subtitle-2">{{ selectedAgentDetails.name || selectedMarker.agentName }}</div>
                              <div class="text-caption" style="opacity:0.7;">
                                User Code: {{ selectedAgentDetails.user_code || selectedMarker.user_code || '-' }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <div class="d-flex align-center">
                          <v-btn size="small" class="custom_btn_primary" @click="locateMarker(selectedMarker)">
                            Locate
                          </v-btn>
                          <v-spacer></v-spacer>
                        </div>
                      </v-card-text>
                    </v-card>
                  </GMapInfoWindow>
                </GMapMap>
              </div>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="4" lg="3">
              <div v-if="filterOpen" class="filter-panel">
                <v-card class="custom_card_box panel-card" elevation="3" rounded="xl">
                  <v-card-text class="pa-4 pa-sm-5">
                    <div class="d-flex justify-space-between align-center">
                      <div class="panel-title">USE A FILTER TO IMPROVE YOUR ANALYSIS</div>
                      <v-btn icon variant="text" size="small" class="close-btn" @click="filterOpen = false">
                        <v-icon size="18">mdi-close</v-icon>
                      </v-btn>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <div class="panel-subtitle mb-3">
                      List of all live sales reps &amp; their details.
                    </div>

                    <v-divider class="my-3"></v-divider>


                    <v-text-field
                        v-model="searchAgent"
                        clearable
                        label="Search"
                        placeholder="Search data"
                        density="comfortable"
                        variant="outlined"
                        class="custom_input_field_color search-field mb-4"
                        append-inner-icon="mdi-magnify"
                        hide-details
                    />

                    <div class="filter-list">
                      <v-card
                          v-for="a in pusherAgents"
                          :key="a.agentId"
                          class="agent-card mb-3"
                          elevation="0"
                          rounded="lg"
                      >
                        <v-card-text class="py-3 px-3 d-flex align-center">
                          <v-avatar size="46" class="mr-3">
                            <v-img :src="agentAvatar(a)" cover />
                          </v-avatar>

                          <div class="flex-grow-1 overflow-hidden pr-2" style="min-width: 0;">
                            <div class="agent-name text-truncate" :title="a.agentName || 'Unknown'">{{ a.agentName || "Unknown" }}</div>
                            <div class="agent-reg" :title="a.user_code || '-'">
                              User Code: {{ a.user_code || "-" }}
                            </div>
                          </div>

                          <div class="d-flex flex-column align-end mr-2 toggle-wrap flex-shrink-0">
                            <div class="d-flex align-center mb-1">
                              <v-checkbox
                                  :model-value="selectedRouteAgentId === a.agentId"
                                  @update:model-value="() => fetchAndDrawRoute(a)"
                                  color="success"
                                  hide-details
                                  density="compact"
                                  class="agent-switch mr-2"
                              />
                              <span class="enable-text">Show Route</span>
                            </div>
                            <div class="d-flex align-center">
                              <!-- UPDATED: Switch now uses persistent disabled logic -->
                              <v-switch
                                  :model-value="isAgentEnabled(a.agentId)"
                                  @update:model-value="(val) => toggleAgentVisibility(a.agentId, val)"
                                  color="#8e24aa"
                                  hide-details
                                  inset
                                  density="compact"
                                  class="agent-switch"
                              />
                              <span class="enable-text">Enable</span>
                            </div>
                            <div class="permission-text">Tracking permissions</div>
                          </div>

                          <v-btn icon variant="text" class="gps-btn flex-shrink-0" @click="locateAgent(a)">
                            <v-icon size="20">mdi-crosshairs-gps</v-icon>
                          </v-btn>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <div style="height: 340px !important; overflow-y: auto!important;">
                <v-card class="mx-auto mb-3 custom_card_box mr-3" elevation="0" v-for="agent in this.activeAgents" :key="agent.id" border="sm opacity-1" rounded="md">
                  <template v-slot:prepend>
                    <v-avatar :image="require('@/img/w.jpg')" size="60"></v-avatar>
                    <v-btn color=""
                           class="mt-10 ml-10 position-absolute custom_green_btn"
                           icon rounded size="x-small"
                           variant="outlined">
                      <v-icon size="small">mdi-crosshairs-gps</v-icon>
                      <v-tooltip activator="parent" location="top">Locate</v-tooltip>
                    </v-btn>
                  </template>
                  <template v-slot:title>
                    <p class="float-end text-body-2 font-weight-bold mb-1">{{ agent.name }}</p>
                  </template>
                  <template v-slot:item>
                    <p class="float-end font-weight-medium custom_page_main_sub_title_very_small_red text-caption mb-3">{{ agent.registration_num }}</p>
                  </template>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { getPermissions } from "@/plugins/permissions";

export default {
  name: 'TrackingAnalysis',
  components: {},
  data() {
    return {
      permissions: { read: false, write: false, delete: false },
      markerByAgentId: {},
      selectedMarker: null,
      filterOpen: false,

      selectedRouteAgentId: null,
      routeDealers: [],
      dealerRouteGroups: [],
      selectedDealer: null,
      selectedDealerKey: 0,
      agentIdToTrackingId: {},
      routeRequestSeq: 0,

      statusFilter: "all",
      searchAgent: "",


      disabledAgentIds: [],

      markerIconCache: {},
      markerIconPending: {},
      markerIconCacheMeta: {},
      fallbackMarkerIcon: { url: "", scaledSize: { width: 70, height: 70 } },

      mapCenter: { lat: 7.300947677303962, lng: 80.8343047520145 },
      selectedAgent: {},
      selectedAgentDetails: {},

      allOfficerDetails: [],
      totalUsersCount: 0,
      activeAgents: [],
      activeOfficerCount: 0,
      deactiveOfficerCount: 0,
      staleAgentIds: [],
    };
  },

  computed: {
    markersArray() {
      const all = Object.values(this.markerByAgentId || {});
      const visibleAgents = all.filter(m => !this.disabledAgentIds.includes(Number(m.agentId)));

      return visibleAgents.filter(m => {
        if (this.statusFilter === "all") return true;
        if (this.statusFilter === "onTrip") return m.statusKey === "onTrip";
        if (this.statusFilter === "available") return m.statusKey === "available";
        if (this.statusFilter === "notAvailable") return m.statusKey === "notAvailable";
        return true;
      });
    },

    pusherAgents() {
      const all = Object.values(this.markerByAgentId || {});
      const q = (this.searchAgent || "").toLowerCase();

      return all.filter(m => {
        if (this.statusFilter === "all") return true;
        if (this.statusFilter === "onTrip") return m.statusKey === "onTrip";
        if (this.statusFilter === "available") return m.statusKey === "available";
        if (this.statusFilter === "notAvailable") return m.statusKey === "notAvailable";
        return true;
      }).filter(m => {
        if (!q) return true;
        return (
            String(m.agentName || "").toLowerCase().includes(q) ||
            String(m.agent_regnum || "").toLowerCase().includes(q)
        );
      });
    },

    selectedAgentAvatar() {
      const img =
          this.selectedAgentDetails?.user_image ||
          this.selectedAgentDetails?.agent_image ||
          this.selectedMarker?.user_image_url ||
          this.selectedMarker?.user_image ||
          this.selectedMarker?.agent_image ||
          this.selectedMarker?.avatar;

      return this.resolveAvatarUrl(img);
    },
  },

  mounted() {
    // UPDATED: Load the disabled agents from storage
    const stored = localStorage.getItem('tracking_disabled_agents');
    if (stored) {
      try {
        this.disabledAgentIds = JSON.parse(stored).map(Number);
      } catch (e) {
        this.disabledAgentIds = [];
      }
    }
    this.permissions = getPermissions(0, "Module Name");

    // 3. CHECK READ ACCESS
    if (!this.permissions.read) {
      this.showSnackbar ? this.showSnackbar("Access Denied", "error") : alert("Access Denied");
      this.$router.push('/dashboard'); // Redirect to dashboard
    }

    this.fallbackMarkerIcon.url = this.buildPinSvgFallback();
    this.getAllAgentAndCount();
    this.getMobileUsersCount();

    this.countRefreshTimer = setInterval(() => {
      this.getAllAgentAndCount();
      this.getMobileUsersCount();
    }, 60000);

    this.staleCheckTimer = setInterval(() => {
      this.removeStaleAgents();
    }, 30000);

    window.Echo.channel('SFA')
        .listen('LocationUpdated', (e) => {
          console.log('Pusher event received:', e);
          if (!e || !e.location) return;
          this.updateUser(e.location);
        });
  },

  beforeUnmount() {
    if (this.countRefreshTimer) clearInterval(this.countRefreshTimer);
    if (this.staleCheckTimer) clearInterval(this.staleCheckTimer);
  },

  methods: {
    removeStaleAgents() {
      const now = Date.now();
      const timeoutMs = 3 * 60 * 1000; // 3 minutes timeout
      let changed = false;
      const next = { ...this.markerByAgentId };

      for (const id in next) {
        if (now - next[id].updatedAt > timeoutMs) {
          delete next[id];
          if (!this.staleAgentIds.includes(Number(id))) {
            this.staleAgentIds.push(Number(id));
          }
          changed = true;
          if (this.selectedMarker && Number(this.selectedMarker.agentId) === Number(id)) {
             this.closeAgentCard();
          }
        }
      }

      if (changed) {
        this.markerByAgentId = next;
        this.recalculateCounts();
      }
    },

    // UPDATED: Check if an agent should be enabled (switch ON)
    isAgentEnabled(id) {
      const numId = Number(id);
      // Enabled if NOT in the disabled list
      return !this.disabledAgentIds.includes(numId);
    },

    // UPDATED: Toggle enabling/disabling and save to localStorage
    toggleAgentVisibility(id, isEnabled) {
      const numId = Number(id);
      if (isEnabled) {
        // Turning ON: Remove from disabled list
        this.disabledAgentIds = this.disabledAgentIds.filter(x => x !== numId);
      } else {
        // Turning OFF: Add to disabled list
        if (!this.disabledAgentIds.includes(numId)) {
          this.disabledAgentIds.push(numId);
        }
      }
      // Save strictly to local storage
      localStorage.setItem('tracking_disabled_agents', JSON.stringify(this.disabledAgentIds));
    },

    resolveAvatarUrl(rawUrl) {
      if (!rawUrl) {
        return require('@/img/user.jpg');
      }

      if (/^https?:\/\//i.test(rawUrl)) {
        return rawUrl;
      }

      const base = process.env.VUE_APP_IMAGE_PUBLIC_URL || "";
      if (base) {
        const cleanBase = base.replace(/\/+$/, '');
        const cleanUrl = rawUrl.replace(/^\/+/, '');
        return `${cleanBase}/${cleanUrl}`;
      }
      console.log('No image found for', rawUrl);

      return require('@/img/user.jpg');
    },

    // Normalize lat/lng fields from API or pusher payloads
    resolveLatLng(record) {
      if (!record) return null;
      const latRaw = record.lat ?? record.latitude ?? record.Latitude ?? record.LAT ?? record.lattitude;
      const lngRaw = record.lng ?? record.lon ?? record.long ?? record.longitude ?? record.Longitude ?? record.LNG;
      const lat = Number(latRaw);
      const lng = Number(lngRaw);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat, lng };
    },

    resolveAgentId(record) {
      if (!record) return null;
      const rawId = record.agent_id ?? record.user_id ?? record.id ?? record.agentId ?? record.userId;
      const agentId = Number(rawId);
      return Number.isFinite(agentId) ? agentId : null;
    },

    buildPinSvgFallback() {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24">
          <path fill="#e53935" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
          <circle cx="12" cy="9" r="4.2" fill="#ffffff"/>
        </svg>
      `;
      return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
    },

    loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },

    async buildUserPinIcon(avatarUrl) {
      const size = 70;
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext("2d");

      ctx.save();
      ctx.scale(size / 24, size / 24);
      const pinPath = new Path2D("M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z");
      ctx.fillStyle = "#e53935";
      ctx.fill(pinPath);
      ctx.restore();

      const cx = size / 2;
      const cy = size * 0.375;
      const r = size * 0.175;

      try {
        const img = await this.loadImage(avatarUrl);

        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(img, cx - r, cy - r, r * 2, r * 2);
        ctx.restore();

        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.strokeStyle = "#ffffff";
        ctx.lineWidth = 2;
        ctx.stroke();

        return canvas.toDataURL("image/png");
      } catch (err) {
        return this.buildPinSvgFallback();
      }
    },

    async ensureMarkerIcon(agentId, avatarUrl) {
      const id = Number(agentId);
      if (!Number.isFinite(id)) return;

      const normalized = this.resolveAvatarUrl(avatarUrl);
      if (this.markerIconCacheMeta[id] === normalized && this.markerIconCache[id]) return;
      if (this.markerIconPending[id]) return;

      this.markerIconPending[id] = true;

      const url = await this.buildUserPinIcon(normalized);
      this.markerIconCache = {
        ...this.markerIconCache,
        [id]: { url, scaledSize: { width: 70, height: 70 } },
      };
      this.markerIconCacheMeta = {
        ...this.markerIconCacheMeta,
        [id]: normalized,
      };
      this.markerIconPending[id] = false;
    },

    markerIconForMarker(marker) {
      const id = Number(marker?.agentId);
      const avatar =
          marker?.user_image_url ||
          marker?.user_image ||
          marker?.agent_image ||
          marker?.agent_image_url ||
          marker?.avatar ||
          marker?.image_url ||
          marker?.image;

      if (Number.isFinite(id)) {
        this.ensureMarkerIcon(id, avatar);
        if (this.markerIconCache[id]) return this.markerIconCache[id];
      }

      return this.fallbackMarkerIcon;
    },

    updateUser(vehicle) {
      console.log('updateUser called with:', vehicle);
      if (!vehicle) return;

      const payload = vehicle.location || vehicle.position || vehicle;
      const agentId = this.resolveAgentId(payload);
      const coords = this.resolveLatLng(payload);

      if (!Number.isFinite(agentId)) return;

      const isInvalidCoords = !coords || (coords.lat === 0 && coords.lng === 0);
      const isDayOut = payload.type === 'DAY_OUT';
      const isStop = payload.type && payload.type.toUpperCase() === 'STOP';

      if (isInvalidCoords || isDayOut || isStop) {
        if (this.markerByAgentId[agentId]) {
          const next = { ...this.markerByAgentId };
          delete next[agentId];
          this.markerByAgentId = next;
          this.recalculateCounts();
          if (this.selectedMarker && Number(this.selectedMarker.agentId) === agentId) {
             this.closeAgentCard();
          }
        }
        return;
      }

      // Valid update received, remove from stale list
      this.staleAgentIds = this.staleAgentIds.filter(x => x !== agentId);

      // Find existing agent details in allOfficerDetails in case we just rely on live tracker for new info
      const storedAgent = this.allOfficerDetails.find(a => Number(a.id) === agentId);

      const prev = this.markerByAgentId[agentId];
      let statusKey = prev?.statusKey || (storedAgent && Number(storedAgent.active_status) === 1 ? "onTrip" : "available");
      
      if (payload.type === 'DAY_IN' || payload.type === 'LIVE') {
          statusKey = 'onTrip';
      }

      const imageUrl =
          payload.user_image_url ||
          payload.user_image ||
          payload.agent_image ||
          payload.agent_image_url ||
          payload.image_url ||
          payload.image ||
          prev?.user_image_url ||
          "";

      this.markerByAgentId = {
        ...this.markerByAgentId,
        [agentId]: {
          agentId,
          agentName: payload.agent_name || payload.agnet_name || payload.name || prev?.agentName || storedAgent?.agent_name || storedAgent?.name || "",
          agent_regnum: payload.agent_regnum || payload.reg_num || prev?.agent_regnum || storedAgent?.registration_num || "",
          user_code: payload.user_code || prev?.user_code || storedAgent?.user_code || "",
          user_image_url: imageUrl,
          position: { lat: coords.lat, lng: coords.lng },
          updatedAt: Date.now(),
          lastUpdatedText: "just now",
          statusKey,
          statusLabel:
              statusKey === "onTrip" ? "ON TRIP" :
                  statusKey === "available" ? "AVAILABLE" :
                      statusKey === "notAvailable" ? "NOT AVAILABLE" : "STATUS",
          trackingId: payload.tracking_id || payload.trackingId || payload.trackingID || prev?.trackingId || storedAgent?.tracking_id || "",
          date: payload.date || payload.created_at || payload.assigned_date || prev?.date || storedAgent?.date || "",
        }
      };

      this.ensureMarkerIcon(agentId, imageUrl);

      if (this.selectedMarker && Number(this.selectedMarker.agentId) === agentId) {
        this.selectedMarker = this.markerByAgentId[agentId];
      }

      this.recalculateCounts();
    },

    getMobileUsersCount() {
      const token = localStorage.getItem('token');

      axios.get('/api/tracking/mobile-users-count', {
        headers: { Authorization: `Bearer ${token}` }
      })
          .then(response => {
            if (response.status !== 200) {
              console.error("Error:", response.data?.error || response.statusText);
              return;
            }

            this.totalUsersCount = Number(response.data?.totalUsers || 0);
            this.deactiveOfficerCount = Number(response.data?.notAvailableUserCount || 0);
          })
          .catch(err => {
            console.error(err);
          });
    },

    recalculateCounts() {
      this.activeOfficerCount = Object.keys(this.markerByAgentId).length;
    },

    selectAgent(marker) {
      this.selectedAgent = marker;
      this.selectedAgentDetails = {
        name: marker.agentName || "Unknown",
        registration_num: marker.user_code || "-",
        user_code: marker.user_code || "-",
        user_image: marker.user_image_url || marker.user_image || marker.avatar || "",
        address: marker.lastAddress || "",
      };
    },

    getAllAgentAndCount() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      const formData = new FormData();
      formData.append('userId', userId);

      axios.post('/api/getAllAgentAndCount', formData, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
          .then(response => {
            if (response.status !== 200) {
              console.error("Error:", response.data?.error || response.statusText);
              return;
            }

            this.allOfficerDetails = Array.isArray(response.data.ofiicerDetails)
                ? response.data.ofiicerDetails
                : [];

            this.agentIdToTrackingId = this.allOfficerDetails.reduce((acc, item) => {
              const trackingId = item.tracking_id || item.trackingId || item.trackingID;
              const id = Number(item.id ?? item.agent_id ?? item.user_id);
              if (trackingId && Number.isFinite(id)) acc[id] = trackingId;
              return acc;
            }, {});

            this.trackingIdToAgentId = this.allOfficerDetails.reduce((acc, item) => {
              const trackingId = item.tracking_id || item.trackingId || item.trackingID;
              const id = Number(item.id ?? item.agent_id ?? item.user_id);
              if (trackingId && Number.isFinite(id)) acc[trackingId] = id;
              return acc;
            }, {});

            this.activeOfficerCount = Number(response.data.getActiveOfiicer || 0);

            this.$store.dispatch('updateAgentList', this.allOfficerDetails);

            const next = { ...(this.markerByAgentId || {}) };

            this.allOfficerDetails.forEach(o => {
              const id = this.resolveAgentId(o);
              if (!Number.isFinite(id)) return;

              const statusKey = Number(o.active_status) === 1 ? "onTrip" : "available";

              const coords = this.resolveLatLng(o);
              const hasPosition = !!coords && coords.lat !== 0 && coords.lng !== 0;

              if (!hasPosition) {
                if (next[id]) delete next[id];
              } else if (next[id]) {
                next[id] = {
                  ...next[id],
                  statusKey,
                  statusLabel: statusKey === "onTrip" ? "ON TRIP" : "AVAILABLE",
                };
              } else if (hasPosition) {
                if (this.staleAgentIds.includes(id)) return; // Skip re-adding if stale

                const imageUrl = o.user_image_url || o.user_image || o.agent_image || o.agent_image_url || o.image_url || o.image || "";
                next[id] = {
                  agentId: id,
                  agentName: o.agent_name || o.agnet_name || o.name || "",
                  agent_regnum: o.user_code || o.reg_num || o.registration_num || "",
                  user_code: o.user_code || "",
                  user_image_url: imageUrl,
                  position: { lat: coords.lat, lng: coords.lng },
                  updatedAt: Date.now(),
                  lastUpdatedText: "from snapshot",
                  statusKey,
                  statusLabel: statusKey === "onTrip" ? "ON TRIP" : "AVAILABLE",
                  trackingId: o.tracking_id || o.trackingId || o.trackingID || "",
                  date: o.date || o.created_at || o.assigned_date || "",
                };
                this.ensureMarkerIcon(id, imageUrl);
              }
            });
            this.markerByAgentId = next;
            this.recalculateCounts();
          })
          .catch(err => {
            console.error(err);
          });
    },

    selectMarker(marker) {
      this.selectedMarker = marker;
      this.selectAgent(marker);
    },

    closeAgentCard() {
      this.selectedMarker = null;
      this.selectedAgent = null;
      this.selectedAgentDetails = {};
    },

    locateMarker(marker) {
      if (!marker || !marker.position) return;
      this.mapCenter = { ...marker.position };
    },

    locateAgent(agent) {
      const id = Number(agent.agentId ?? agent.id);
      const m = this.markerByAgentId?.[id];
      if (m?.position) {
        this.locateMarker(m);
        this.selectedMarker = m;
        this.selectAgent(m);
      }
    },

    async selectDealer(dealer) {
      if (!dealer) return;
      const sameDealer = this.selectedDealer && this.selectedDealer.id === dealer.id;
      this.selectedDealer = null;
      if (sameDealer) {
        await this.$nextTick();
      }
      this.selectedDealer = dealer;
      this.selectedDealerKey += 1;
    },

    closeDealerCard() {
      this.selectedDealer = null;
    },

    async fetchAndDrawRoute(agent) {
      if (this.selectedRouteAgentId === agent.agentId) {
        this.selectedRouteAgentId = null;
        this.routeDealers = [];
        this.dealerRouteGroups = [];
        this.closeDealerCard();
        this.routeRequestSeq += 1;
        return;
      }

      this.selectedRouteAgentId = agent.agentId;
      const requestId = this.routeRequestSeq + 1;
      this.routeRequestSeq = requestId;
      const agentId = Number(agent.agentId ?? agent.id);
      const markerDate = this.markerByAgentId?.[agentId]?.date;
      let date = this.normalizeRouteDate(markerDate);
      if (!date) {
        date = new Date().toISOString().slice(0, 10);
      }
      const token = localStorage.getItem('token');
      console.log("token", token);

      try {
        const response = await axios.get('/api/routes/by-date-salesrep', {
          params: { saleRep_id: agent.agentId, date },
          headers: { Authorization: `Bearer ${token}` }
        });

        if (this.selectedRouteAgentId !== agent.agentId || requestId !== this.routeRequestSeq) {
          return;
        }

        if (response.data && response.data.success && Array.isArray(response.data.data)) {
          let allDealers = [];
          const routesDealersList = [];

          response.data.data.forEach(route => {
            if (route.dealers && Array.isArray(route.dealers) && route.dealers.length > 0) {
              route.dealers.forEach(d => {
                d.latitude = d.latitude ?? d.lat ?? d.lattitude ?? d.Latitude;
                d.longitude = d.longitude ?? d.lng ?? d.lon ?? d.long ?? d.Longitude;
              });
              allDealers = allDealers.concat(route.dealers);
              routesDealersList.push({
                dealers: route.dealers,
                routeName: route.route_name || "",
                routeId: route.id,
              });
            }
          });
          this.routeDealers = allDealers;
          this.calculateAndDrawDirections(routesDealersList, agent.agentId, requestId);
        } else {
          // If no data, clear map
          this.routeDealers = [];
          this.dealerRouteGroups = [];
        }
      } catch (e) {
        console.error("Failed to fetch route dealers", e);
      }
    },

    async calculateAndDrawDirections(routesDealersList, activeAgentId, requestId) {
      this.dealerRouteGroups = [];

      if (!routesDealersList || routesDealersList.length === 0) {
        return;
      }

      const shouldAbort = () => this.selectedRouteAgentId !== activeAgentId || requestId !== this.routeRequestSeq;
      if (shouldAbort()) return;

      const colors = ["#2A8200", "#7C3AED", "#2563EB", "#562b2b", "#0F766E", "#D97706", "#9333EA", "#EA580C", "#0891B2", "#BE185D", "#65A30D", "#B45309"];
      const routeGroups = [];
      const colorByRouteId = {};
      const getRouteKey = (routeItem, index) => {
        const rawId = routeItem?.routeId ?? routeItem?.route_id;
        if (rawId === undefined || rawId === null || rawId === "") return `route-unknown-${index}`;
        return String(rawId);
      };
      const upsertGroup = (routeKey, routeItem) => {
        let group = routeGroups.find((g) => g.routeId === routeKey);
        if (!group) {
          const color = colorByRouteId[routeKey] || pickNextColor();
          colorByRouteId[routeKey] = color;
          group = {
            routeId: routeKey,
            routeName: routeItem?.routeName || "",
            color,
            segments: [],
          };
          routeGroups.push(group);
        }
        return group;
      };
      const directionsService = new window.google.maps.DirectionsService();
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));
      const requestRoutePath = async (request, maxRetries = 6) => {
        let attempt = 0;
        let backoffMs = 1000;

        while (attempt < maxRetries) {
          const { result, status } = await new Promise((resolve) => {
            try {
              directionsService.route(request, (result, status) => resolve({ result, status }));
            } catch (err) {
              resolve({ result: null, status: "EXCEPTION" });
            }
          });

          if (status === window.google.maps.DirectionsStatus.OK && result?.routes?.[0]?.overview_path) {
            return result.routes[0].overview_path.map((p) => ({
              lat: typeof p.lat === "function" ? p.lat() : p.lat,
              lng: typeof p.lng === "function" ? p.lng() : p.lng,
            }));
          }

          if (status === window.google.maps.DirectionsStatus.OVER_QUERY_LIMIT || status === window.google.maps.DirectionsStatus.UNKNOWN_ERROR) {
            await delay(backoffMs);
            backoffMs *= 2;
            attempt += 1;
            continue;
          }

          console.warn("Directions request failed due to " + status);
          return null;
        }

        console.warn("Directions request failed after retries.");
        return null;
      };

      // usedColorSet tracks assigned colors; reset when all colors are exhausted
      const usedColorSet = new Set();
      const pickNextColor = () => {
        if (usedColorSet.size >= colors.length) usedColorSet.clear();
        for (let c = 0; c < colors.length; c++) {
          if (!usedColorSet.has(colors[c])) {
            usedColorSet.add(colors[c]);
            return colors[c];
          }
        }
        return colors[0];
      };

      for (let index = 0; index < routesDealersList.length; index++) {
        if (shouldAbort()) return;
        const routeItem = routesDealersList[index];
        const dealers = routeItem?.dealers;
        const cleanDealers = Array.isArray(dealers)
          ? dealers.filter(d => Number.isFinite(Number(d.latitude)) && Number.isFinite(Number(d.longitude)))
          : [];
        if (cleanDealers.length < 2) continue;

        const routeKey = getRouteKey(routeItem, index);
        const group = upsertGroup(routeKey, routeItem);

        for (let i = 0; i < cleanDealers.length - 1; i += 1) {
          if (shouldAbort()) return;
          const originDealer = cleanDealers[i];
          const destDealer = cleanDealers[i + 1];

          const origin = { lat: Number(originDealer.latitude), lng: Number(originDealer.longitude) };
          const destination = { lat: Number(destDealer.latitude), lng: Number(destDealer.longitude) };

          const request = {
            origin,
            destination,
            travelMode: window.google.maps.TravelMode.DRIVING
          };

          const path = await requestRoutePath(request);
          if (path && path.length > 0) {
            if (shouldAbort()) return;
            group.segments.push(path);
            this.dealerRouteGroups = [...routeGroups];
          }

          // await delay(1200); // Throttle to reduce OVER_QUERY_LIMIT
        }

        // await delay(1500); // Small pause between routes
      }
    },

    agentAvatar(agent) {
      const url =
          agent?.user_image_url ||
          agent?.user_image ||
          agent?.agent_image ||
          agent?.agent_image_url ||
          agent?.avatar ||
          agent?.image_url ||
          agent?.image;

      return this.resolveAvatarUrl(url);
    },

    allAgents() {
      this.$router.push('/all-agents');
    },

    idling() {
      this.$router.push('/idling-agents');
    },

    parking() {
      this.$router.push('/parking-agents');
    },

    back() {
      this.$router.push('/dashboard');
    },

    normalizeRouteDate(rawDate) {
      if (!rawDate) return "";
      if (rawDate instanceof Date && !isNaN(rawDate.getTime())) {
        return rawDate.toISOString().slice(0, 10);
      }
      const str = String(rawDate).trim();
      const match = str.match(/\d{4}-\d{2}-\d{2}/);
      if (match) return match[0];
      const parsed = new Date(str);
      if (!isNaN(parsed.getTime())) return parsed.toISOString().slice(0, 10);
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../styles/tracking_management/live_tracking.scss" as *;
</style>
